module.exports = __webpack_public_path__ + "static/timeline1996-2-c7db2ba4ccb129b99b3c9a787b959140.jpeg";